import axios from "axios";

export default {
    async Table(data){
        const response = await axios.post(`/api/companysystemconstantparameter/table`,data)
        return response
    },
    async CreateOrUpdate(editing,data){
        const response = await axios.post(editing? '/api/companysystemconstantparameter/update':'/api/companysystemconstantparameter/create',data)
        return response
    },
    async Delete(data){
        const response = await axios.post(`/api/companysystemconstantparameter/delete/${data}`)
        return response
    },
    async GetByCode(code){
        const response = await axios.get(`/api/companysystemconstantparameter/get/bycode/${code}`)
        return response
    },
    async GetListByCode(code){
        const response = await axios.get(`/api/companysystemconstantparameter/getlist/bycode/${code}`)
        return response
    },
    async TableCategory(data){
        const response = await axios.post(`/api/companysystemconstantparameter/get/bycategorycode`,data)
        return response
    },
}